import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "w100 fl" }
const _hoisted_3 = {
  key: 1,
  id: "zoomList"
}
const _hoisted_4 = ["id", "value"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_6 = { key: 2 }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "fl text-left mr5" }
const _hoisted_9 = { class: "fl" }
const _hoisted_10 = ["src"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "grey" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextfieldTag = _resolveComponent("TextfieldTag")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.Util.isPresent(_ctx.zoomLoctags))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (!_ctx.maxLength || (_ctx.selectedZooms || []).length < _ctx.maxLength)
              ? (_openBlock(), _createBlock(_component_TextfieldTag, {
                  key: 0,
                  placeholder: `${_ctx.provider == `teams` ? `Teams` : `Zoom`}アカウントを選択`,
                  style: {"border-bottom":"solid 1px #c8c8c8"},
                  class: "cal_blanks fw600 fl fs12",
                  list: "zoomList",
                  id: "zoomAccounts",
                  value: _ctx.currentZoomEmail,
                  onInputValue: _ctx.addZoom
                }, null, 8, ["placeholder", "value", "onInputValue"]))
              : _createCommentVNode("", true),
            (_ctx.Util.isPresent(_ctx.unselectedZooms))
              ? (_openBlock(), _createElementBlock("datalist", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.unselectedZooms, (zoom, zoomindex) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: zoomindex,
                      id: zoom.search_key,
                      value: zoom.email,
                      class: _normalizeClass(zoom.email),
                      onSelect: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addZoom && _ctx.addZoom(...args)))
                    }, _toDisplayString(zoom.email), 43, _hoisted_4))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _hoisted_5,
            (_ctx.Util.isPresent(_ctx.selectedZooms))
              ? (_openBlock(), _createElementBlock("ul", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedZooms, (zoom, zoomindex) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: _normalizeClass(`pointer ${zoomindex % 2 == 0 ? `llgreyBg` : ``}`),
                      style: {"line-height":"30px"},
                      key: zoomindex,
                      onClick: ($event: any) => (_ctx.deselectZoom(zoom))
                    }, [
                      _createElementVNode("span", _hoisted_8, _toDisplayString(zoomindex + 1), 1),
                      _createElementVNode("span", _hoisted_9, _toDisplayString(zoom.email), 1),
                      _createElementVNode("img", {
                        src: _ctx.$getAssetImageUrl(`/assets/icons/close_circle.png`),
                        width: "16",
                        height: "17",
                        style: {},
                        class: "fr mt5 mr15"
                      }, null, 8, _hoisted_10),
                      _hoisted_11
                    ], 10, _hoisted_7))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("p", _hoisted_13, "連携できる" + _toDisplayString(_ctx.provider == `teams` ? `Teams` : `Zoom`) + "アカウントがありませんでした。", 1),
          _createElementVNode("section", {
            class: "pointer centered circle_button skyblueBg fs14 rad8 fw600",
            style: {"width":"220px","height":"44px","padding":"14px 8px"},
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goZoom && _ctx.goZoom(...args)))
          }, _toDisplayString(_ctx.provider == `teams` ? `Teams` : `Zoom`) + "アカウントを連携する ", 1)
        ]))
  ]))
}